import {
  ErwerberVeraeussererDetailEntryMeta,
  GbvertragService,
  HandelsangabenDetailEntryMeta,
  PersonGbListEntryMeta,
  PersonGbVersionDetailEntryMeta,
  TimePointId,
  VertragDetailEntryMeta,
  VertragsdatenDetailEntryMeta,
  ZusatzangabenDetailEntryMeta
} from '../../../../core/gb-api';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ZusatzangabenDetailComponent } from './zusatzangaben-detail/zusatzangaben-detail.component';
import { HandelsangabenDetailComponent } from './handelsangaben-detail/handelsangaben-detail.component';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { Subscription } from 'rxjs';
import { LinkComponent, NavTarget } from '../../../../shared/components/link/link.component';
import { ComparatorService } from '../../../../shared/services/comparator-service';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { ListLoader } from '../../../../shared/components/list-loader/list-loader';
import { ListLoaderPreloaded } from '../../../../shared/components/list-loader/list-loader-preloaded';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { KompaktGrundstueckPipe } from '../../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe';
import { KompaktGrundstueckbeschreibungPipe } from '../../../../shared/kompaktdarstellung/grundstueck-beschreibung/kompakt-grundstueckbeschreibung.pipe';
import {
  GrundstueckListEntryVm,
  GrundstueckSelection,
  GrundstueckTableComponent
} from '../../../../shared/widgets/grundstueck-table/grundstueck-table.component';
import { DokulinkItemBuilderFactory } from 'app/shared/components/dokulink/dokulinkItemBuilderFactory';
import { BelegAltReferenzObjektTyp } from '../../../../shared/components/dokulink/dokulinkItem';
import { GrundstuecknummerPipe } from '../../../../shared/pipes/simple/grundstuecknummer.pipe';
import { ErweiterungConfigResponse } from '../../../../core/base-api';
import { GbPrintService } from '../../../../core/services/app-print.service';
import { AuszugPrintService } from '../../../../shared/components/auszug/auszug-print-service';
import { GrundstueckAuszugSettingsComponent } from '../../../../shared/components/auszug/settings/grundstueck-auszug-settings.component';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { ContentHeaderComponent } from '../../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../../shared/components/title-functionbar/title-functionbar.component';
import { CapSpinnerSmallComponent } from '../../../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { HistoryDirective } from '../../../../shared/directives/history.directive';
import { KompaktPersongbComponent } from '../../../../shared/kompaktdarstellung/persongb/kompakt-persongb.component';
import { KompaktZusatzangabenComponent } from '../../../../shared/kompaktdarstellung/zusatzangaben/kompakt-zusatzangaben.component';
import { BetragPipe } from '../../../../shared/pipes/simple/betrag.pipe';
import { DatumPipe } from '../../../../shared/pipes/simple/datum.pipe';
import { KompaktHandelsangabenPipe } from '../../../../shared/kompaktdarstellung/handelsangaben/kompakt-handelsangaben.pipe';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';
import { YesNoPipe } from '../../../../shared/pipes/simple/yes-no.pipe';
import RechtsgrundArtEnum = VertragsdatenDetailEntryMeta.RechtsgrundArtEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;
import AuskunftsperreEnum = PersonGbListEntryMeta.AuskunftsperreEnum;

@Component({
  selector: 'cap-vertragsdaten',
  templateUrl: './vertragsdaten.component.html',
  styleUrls: ['./vertragsdaten.component.scss'],
  imports: [
    KopfdatenelementComponent,
    TranslatePipe,
    CapFormRowDirective,
    NgTemplateOutlet,
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    GrundstueckTableComponent,
    CapSpinnerSmallComponent,
    HistoryDirective,
    LinkComponent,
    NgStyle,
    KompaktPersongbComponent,
    KompaktZusatzangabenComponent,
    NgbTooltip,
    BetragPipe,
    DatumPipe,
    GrundstuecknummerPipe,
    KompaktGrundstueckPipe,
    KompaktHandelsangabenPipe,
    TranslateNamePipe,
    YesNoPipe
  ]
})
export class VertragsdatenComponent implements OnInit, OnDestroy {
  @Input()
  referenzObjectId: string;

  @Input()
  referenzObjectArt: BelegAltReferenzObjektTyp;

  navTargets = NavTarget;

  vertraege: Array<VertragDetailEntryMeta>;
  vertragsdatenEntryVm: Array<VertragsdatenEntryVm>;
  _timepointId: TimePointId;
  tooltipHandelsangaben = 'tooltipHandelsangaben';
  isHandaenderungsmeldungOn = false;

  parameterErweiterteGbMeldung;

  private subscription: Subscription = new Subscription();
  indexToGrundstueckIds = new Map<number, string[]>([]);

  constructor(
    private vertagService: GbvertragService,
    private comperatorService: ComparatorService,
    private appformatConfigService: FormatConfigService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private kompaktGrundstueckPipe: KompaktGrundstueckPipe,
    private kompaktGrundstueckBeschreibung: KompaktGrundstueckbeschreibungPipe,
    private grundstuecknummerPipe: GrundstuecknummerPipe,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory,
    public gbPrintService: GbPrintService,
    private auszugService: AuszugPrintService
  ) {
    keysToTranslate<string>([
      'vertragsdatensatz',
      'Vertragsart',
      'DatumVertragsabschluss',
      'DatumNutzenUndGefahr',
      'AusserbuchlicherUebergang',
      'KurzdeklarationBeilage',
      'Gesamtpreis',
      'EnthalteneZugaben',
      'SonderpreisZugabe',
      'SchulduebernahmeTotal',
      'UebernahmeGrundstueckgewinnsteuer',
      'Eigentumsform',
      'Zusatzangaben',
      'Handelsangaben',
      'tooltipHandelsangaben',
      'tooltipZusatzangaben',
      'vertragsdaten.Eigentuemer',
      'vertragsdaten.RechtsgrundArt',
      'vertragsdaten.RechtsgrundArt.HANDAENDERUNG_DRITTE',
      'vertragsdaten.RechtsgrundArt.HANDAENDERUNG_ERBEN',
      'vertragsdaten.RechtsgrundArt.HANDAENDERUNG_EHEGATTEN',
      'vertragsdaten.RechtsgrundArt.HANDAENDERUNG_GESELLSCHAFTEN',
      'vertragsdaten.RechtsgrundArt.HANDAENDERUNG_SPEZIAL',
      'vertragsdaten.RechtsgrundArt.GRENZAENDERUNG_SPEZIAL',
      'vertragsdaten.RechtsgrundArt.SONSTIGE_SPEZIAL',
      'vertragsdaten.RechtsgrundArt.ANDERE'
    ]);
  }

  @Input()
  set timepointId(value: TimePointId) {
    if (!value) {
      return;
    }
    this._timepointId = value;

    this.update();
  }

  update() {
    this.subscription.add(
      this.vertagService.loadVertraegeSichtGbMeldung(this._timepointId.id).subscribe((vertraege) => {
        this.vertraege = vertraege;
        for (const vertrag of vertraege) {
          this.createViewModel(vertrag.vertragsdaten);
        }
      })
    );
  }

  ngOnInit() {
    this.subscription.add(
      this.appformatConfigService.erweiterungsConfig$.subscribe((erweiterungConfig) => {
        this.isHandaenderungsmeldungOn = erweiterungConfig.activeErweiterungen.includes(ActiveErweiterungenEnum.HANDAENDERUNGSMELDUNG);
      })
    );
    this.subscription.add(
      this.appformatConfigService.parameterConfig$.subscribe((config) => {
        this.parameterErweiterteGbMeldung = config?.parameters.ANZEIGE_ERWEITERTE_GBMELDUNG_INTERCAPI;
      })
    );
  }

  private createViewModel(vertragsdaten: VertragsdatenDetailEntryMeta[]) {
    this.vertragsdatenEntryVm = new Array<VertragsdatenEntryVm>();
    for (const v of vertragsdaten) {
      const entry = new VertragsdatenEntryVm(
        v,
        this.comperatorService,
        this.translate,
        this.kompaktGrundstueckPipe,
        this.kompaktGrundstueckBeschreibung,
        this.grundstuecknummerPipe,
        this.dokuLinkBuilderFactory
      );
      this.vertragsdatenEntryVm.push(entry);
    }
  }

  translateRechtsgrundArt(e: RechtsgrundArtEnum): string {
    if (e) {
      return this.translate.instant('vertragsdaten.RechtsgrundArt.' + e);
    }
    return '';
  }

  showZusatzangaben(
    item: ZusatzangabenDetailEntryMeta,
    person: PersonGbVersionDetailEntryMeta,
    auskunftsperre: AuskunftsperreEnum,
    veraeusserer: ErwerberVeraeussererDetailEntryMeta
  ) {
    const modalRef = this.modalService.open(ZusatzangabenDetailComponent, { size: 'lg' });
    modalRef.componentInstance.zusatzangaben = item;
    modalRef.componentInstance.gbPerson = person;
    modalRef.componentInstance.auskunftsperre = auskunftsperre;
    modalRef.componentInstance.veraeusserer = veraeusserer;
    modalRef.componentInstance.referenzObjectId = this.referenzObjectId;
    modalRef.componentInstance.referenzObjectArt = this.referenzObjectArt;
  }

  showHandelsangaben(
    item: HandelsangabenDetailEntryMeta,
    person: PersonGbVersionDetailEntryMeta,
    auskunftsperre: AuskunftsperreEnum,
    erwerberVeraeusserer: ErwerberVeraeussererDetailEntryMeta
  ) {
    const modalRef = this.modalService.open(HandelsangabenDetailComponent, { size: 'lg' });
    modalRef.componentInstance.handelsangaben = item;
    modalRef.componentInstance.gbPerson = person;
    modalRef.componentInstance.auskunftsperre = auskunftsperre;
    modalRef.componentInstance.erwerberVeraeusserer = erwerberVeraeusserer;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  getZip(index: number) {
    if (this.indexToGrundstueckIds.has(index)) {
      this.selectGrundstueckSettings(this.indexToGrundstueckIds.get(index), index);
    }
  }

  updateCheckedGrundstueckIdList($event: GrundstueckSelection) {
    if (!this.indexToGrundstueckIds.has($event.index)) {
      this.indexToGrundstueckIds.set($event.index, $event.grundstueckIds);
    } else {
      this.indexToGrundstueckIds.delete($event.index);
      this.indexToGrundstueckIds.set($event.index, $event.grundstueckIds);
    }
  }

  selectGrundstueckSettings(list, indexNumber) {
    const modalRef = this.modalService.open(GrundstueckAuszugSettingsComponent);
    modalRef.componentInstance.hasToZip = true;
    modalRef.componentInstance.ids = list;
    modalRef.componentInstance.indexNumber = indexNumber;
  }

  getSelectedGrunstueckeLength(index: number) {
    if (this.indexToGrundstueckIds.has(index)) {
      let grundstueckIds = this.indexToGrundstueckIds.get(index) as string[];
      return grundstueckIds.length;
    }
    return 0;
  }

  isZippingInProgress(index: number) {
    if (this.gbPrintService.zipInProgressMap.has(index)) {
      return this.gbPrintService.zipInProgressMap.get(index);
    }
    return false;
  }
}

class VertragsdatenEntryVm {
  public erwerber: VeraeussererErwerberParentNode[];
  public veraeusserer: VeraeussererErwerberParentNode[];
  public grundstueckeLoader: ListLoader<GrundstueckListEntryVm>;

  constructor(
    public object: VertragsdatenDetailEntryMeta,
    private comperatorService: ComparatorService,
    private translate: TranslateService,
    private kompaktGrundstueckPipe: KompaktGrundstueckPipe,
    private kompaktGrundstueckBeschreibung: KompaktGrundstueckbeschreibungPipe,
    private grundstuecknummerPipe: GrundstuecknummerPipe,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory
  ) {
    const vms = this.object.grundstuecke.map(
      (g) =>
        new GrundstueckListEntryVm(g, {
          translate: this.translate,
          grundstuecknummerPipe: this.grundstuecknummerPipe,
          kompaktGrundstueckBeschreibung: this.kompaktGrundstueckBeschreibung,
          kompaktGrundstueckPipe: this.kompaktGrundstueckPipe,
          dokuLinkBuilderFactory: this.dokuLinkBuilderFactory
        })
    );
    this.grundstueckeLoader = new ListLoaderPreloaded<GrundstueckListEntryVm>(15, 1, vms);

    this.erwerber = new Array<VeraeussererErwerberParentNode>();
    this.veraeusserer = new Array<VeraeussererErwerberParentNode>();
    const allErwerber = object.erwerberVeraeusserer.filter((ev) => ev.beteiligung === 'ERWERBER');
    for (const e of allErwerber) {
      if (!e.parentId) {
        allErwerber.filter((o) => o.id.id === e.id.id);
        this.erwerber.push(new VeraeussererErwerberParentNode(e, allErwerber, 0));
      }
    }

    const allVeraeusserer = object.erwerberVeraeusserer.filter((ev) => ev.beteiligung === 'VERAEUSSERER');
    for (const v of allVeraeusserer) {
      if (!v.parentId) {
        allVeraeusserer.filter((o) => o.id.id === v.id.id);
        v?.zusatzangaben.sort((a, b) => this.comperatorService.orderByComparator(a.datum, b.datum));
        this.veraeusserer.push(new VeraeussererErwerberParentNode(v, allVeraeusserer, 0));
      }
    }
    this.erwerber.sort((a, b) =>
      this.comperatorService.grundstueckComparator(
        a.object.eigentumAnteil.belastetesGrundstueck,
        b.object.eigentumAnteil.belastetesGrundstueck
      )
    );
    this.veraeusserer.sort((a, b) =>
      this.comperatorService.grundstueckComparator(
        a.object.eigentumAnteil.belastetesGrundstueck,
        b.object.eigentumAnteil.belastetesGrundstueck
      )
    );
  }
}

class VeraeussererErwerberParentNode {
  children: VeraeussererErwerberParentNode[];
  level: number;

  constructor(
    public object: ErwerberVeraeussererDetailEntryMeta,
    private allErwerber: ErwerberVeraeussererDetailEntryMeta[],
    level: number
  ) {
    this.level = level;
    this.children = new Array<VeraeussererErwerberParentNode>();
    for (const erwerber of allErwerber) {
      if (erwerber.parentId && erwerber.parentId.id === object.id.id) {
        this.children.push(new VeraeussererErwerberParentNode(erwerber, allErwerber, level + 1));
      }
    }
  }

  get indent() {
    return {
      'padding-left': this.level * 10 + 'px'
    };
  }
}
